export class SearchParam {
  Search?: string;
  SearchReferences?: boolean;

  SearchFields: string[] = [];

  Filters: SearchFilter[] = [];

  Joins: SearchJoin[] = [];

  Fields: string[] = [];

  OrderBy: SearchOrder[] = [];

  Condition: SearchCondition = SearchCondition.And;

  IncludeDeleted = false;

  constructor(initial?: Partial<SearchParam>) {
    if (initial) {
      Object.assign(this, initial);
    }
  }
}
export interface SearchJoin {
  /**
   * Name of the backend model being joined.
   *
   * The backend should resolve this string to a permitted CLR type.
   */
  Model: string;

  LocalField: string;
  ForeignField: string;
  Type: JoinType;
  Alias?: string;
  Fields: string[];
}

export enum SearchOperator {
  EQ = "EQ",
  NEQ = "NEQ",
  GT = "GT",
  GTE = "GTE",
  LT = "LT",
  LTE = "LTE",
  Contains = "Contains",
  StartsWith = "StartsWith",
  EndsWith = "EndsWith",
  In = "In",
  NotIn = "NotIn",
  IsNull = "IsNull",
  IsNotNull = "IsNotNull",
  Between = "Between",
  NotBetween = "NotBetween",
}

export enum SearchCondition {
  And = "And",
  Or = "Or",
}

export enum JoinType {
  Inner = "Inner",
  LeftOuter = "LeftOuter",
  RightOuter = "RightOuter",
  FullOuter = "FullOuter",
}

export interface SearchFilter {
  Field: string;
  Operator: SearchOperator;
  Value?: unknown;
}

export interface SearchOrder {
  Field: string;
  Descending: boolean;
}
